import { render, staticRenderFns } from "./DrawerPermanent.vue?vue&type=template&id=c8bc4412&"
import script from "./DrawerPermanent.vue?vue&type=script&lang=js&"
export * from "./DrawerPermanent.vue?vue&type=script&lang=js&"
import style0 from "./DrawerPermanent.vue?vue&type=style&index=0&id=c8bc4412&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports